import { GadgetProxy } from '../school/gadget-host/gadget-proxy';
import { GadgetService } from '../school/gadget.service';
import { DynamicGadgetGUID, GadgetMetadata } from './gadget_model';

export class GadgetDeployMetadata {
  [x: string]: any;
  id?: string;
  dsns: string;
  targetType: string;
  targetTitle: string;
  params: any;
  lang?: Language;
  module?: GadgetMetadata;
  displayOrder: number;
  enabled: boolean;

  public static create(rec: Partial<GadgetDeployMetadata>) {
    return Object.assign(new GadgetDeployMetadata(), rec as GadgetDeployMetadata);
  }

  getTitle(lang: Language) {
    return this.module.getTitle(lang, this.params);
  }

  getIcon() {
    return this.module.getIconURL(this.params);
  }

  getIsPopup() {
    return this.module.isPopup();
  }

  getUrl() {
    return this.module.getURL(this.dsns, this.targetTitle, this.params, this.id);
  }

  getGuid() {
    return this.module.getGuid();
  }

  /** 取得靜態全域識別。一般來說會是 gadget guid，但是在動態的 gadget 時，會加上其他的資訊識別。 */
  getGlobalStaticID() {
    const params = this.params;

    if (this.getGuid() === DynamicGadgetGUID) {
      if (!params) { return this.getGuid(); }

      if (params.static_id) {
        return `${this.getGuid()}:${params.static_id || ''}`;
      } else {
        // 固定取 zh-TW 就好。
        return `${this.getGuid()}:${this.getTitle('zh-TW')?.trim() || ''}`;
      }
    }

    return this.getGuid();
  }

  getArchitecture() {
    return this.module.architecture;
  }

  getIntegrationMethod() {
    return this.module.getIntegrationMethod(this.params);
  }

  /** 用於傳送到 web2 的模擬 iframe 中。 */
  public getAgentArgs() {
    return {
      id: GadgetProxy.generateId(this),
      dsns: this.dsns,
      targetType: this.targetType,
      guid: this.getGuid(),
      params: this.params,
    } as AgentArguments;
  }
}

export interface AgentArguments {
  [x: string]: any,
  id: string;
  dsns: string;
  targetType: string;
  guid: string;
  params: any;
}
